import React from 'react';
import { DialogControl } from 'spark-core-dx/components';
import { useDashboardDomainContext } from '../../DashboardDomainProvider';

const RevertChangesDialog = ({ isActive, closeDialog }) => {
  const { dashboardLib } = useDashboardDomainContext();

  const published = dashboardLib?.activeDashboard?.PublishedDetails;
  const draft = dashboardLib?.activeDashboard?.DraftDetails;

  const canRevert =
    !!published && JSON.stringify(published) !== JSON.stringify(draft);

  return (
    <DialogControl
      className="dashboard-dialog"
      openDialog={isActive}
      title="Revert Changes"
      disableOk={!canRevert}
      onOk={() => {
        closeDialog();
        dashboardLib.revertChanges();
      }}
      onCancel={() => closeDialog()}
      okText="Continue"
      cancelText="Return"
    >
      <div className="dialog-text">
        To revert to the last published state, click "Continue" or click "Return" to continue editing.
      </div>
    </DialogControl>
  );
};

export default RevertChangesDialog;
